// Pure helpers shared by the Car and Travel booking calendars.
//
// The API colours events for meaning — car bookings by status, travel by
// purpose — as solid blocks with white text. The calendar keeps that meaning
// as an accent (left rule, time, legend) on a soft tint with dark text, which
// reads far better when a day holds several bookings.

// Car status css_name → accent (same palette the API uses for the booking view;
// the driver / car views send only `bg_name`).
export const STATUS_ACCENTS = {
  success: '#16a34a',
  warning: '#d97706',
  danger: '#dc2626',
  primary: '#2563eb',
};
export const DEFAULT_ACCENT = '#64748b';

const HEX6 = /^#([0-9a-f]{6})$/i;

// '#16a34a' + 0.12 → '#16a34a1f'. Anything that is not a 6-digit hex is
// returned unchanged (the browser then shows it opaque — still readable).
export const withAlpha = (hex, alpha) => {
  if (!HEX6.test(String(hex || ''))) return hex;
  const a = Math.round(Math.min(1, Math.max(0, alpha)) * 255).toString(16).padStart(2, '0');
  return `${hex}${a}`;
};

export const accentOf = (event = {}) => (
  event.accent || event.backgroundColor || STATUS_ACCENTS[event.bg_name] || DEFAULT_ACCENT
);

// The API event as the calendar renders it: transparent chrome (styled by CSS
// from --bc-accent / --bc-soft, see bookingCalendar.css), meaning kept in `accent`.
export const toCalendarEvent = (event = {}) => ({
  ...event,
  accent: accentOf(event),
  backgroundColor: 'transparent',
  borderColor: 'transparent',
  textColor: '#1e293b',
});

// Distinct { label, accent } pairs for the legend, in first-seen order.
export const legendOf = (events = [], labelOf) => {
  const seen = new Map();
  events.forEach((event) => {
    const label = labelOf(event);
    if (label && !seen.has(label)) seen.set(label, accentOf(event));
  });
  return [...seen.entries()].map(([label, accent]) => ({ label, accent }));
};
